var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 50,
    viewBox: "0 0 60 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5007 22.1663C24.6303 22.1663 27.1673 19.6293 27.1673 16.4997C27.1673 13.3701 24.6303 10.833 21.5007 10.833C18.371 10.833 15.834 13.3701 15.834 16.4997C15.834 19.6293 18.371 22.1663 21.5007 22.1663Z",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8337 33.4997C32.8337 36.6305 32.8337 39.1663 21.5003 39.1663C10.167 39.1663 10.167 36.6305 10.167 33.4997C10.167 30.3688 15.2387 27.833 21.5003 27.833C27.762 27.833 32.8337 30.3688 32.8337 33.4997Z",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3337 24.9997C58.3337 35.6842 58.3337 41.0278 55.013 44.3457C51.6923 47.6635 46.3515 47.6663 35.667 47.6663H24.3337C13.6492 47.6663 8.30549 47.6663 4.98766 44.3457C1.66983 41.025 1.66699 35.6842 1.66699 24.9997C1.66699 14.3152 1.66699 8.97151 4.98766 5.65367C8.30833 2.33584 13.6492 2.33301 24.3337 2.33301H35.667C46.3515 2.33301 51.6952 2.33301 55.013 5.65367C56.3447 6.98534 57.1408 8.64001 57.6197 10.833M49.8337 24.9997H38.5003M49.8337 16.4997H35.667M49.8337 33.4997H41.3337",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.49f0ab107593dffbe2f774eb790d42ed.svg";
export { ForwardRef as ReactComponent };